<div class="w-full h-full flex flex-col">
  <div class="flex-grow min-h-0 w-full">
    @if (pinnedDocuments.length == 0 && notPinnedDocuments.length == 0) {
      <p class="pl-5">{{ 'DocumentList.NoDocuments'|translate }}</p>
    } @else {
      <app-greedy-scroll-panel>
        @if(pinnedDocuments.length>0) {
        <div class="grid grid-cols-1 gap-2 items-center pb-4">
          @if (pinnedDocuments.length > 0) {
            <div class="flex items-center col-span-2">
              <span class="material-symbols-outlined !text-xl">keep</span>
              {{ pinnedTranslationKey|translate }}
            </div>
          }
          @for (pinnedDocument of pinnedDocuments; track pinnedDocument.id) {
            <div class="flex flex-col pt-1 w-full">
              <div class="flex">
                <div class="flex items-end pr-2">
                  @if (!pinLock){
                  <i class="material-symbols-outlined clickable" (click)="unpinDocument(pinnedDocument)">keep_off</i>
                  }
                  @if (!deletePinnedLock){
                  <i class="material-symbols-outlined text-red-600 clickable"
                     (click)="openDeleteDocumentDialog(pinnedDocument)">delete</i>
                  }
                </div>
                <div class="clickable" (click)="openViewDocumentDialog(pinnedDocument.id)">
                  <div class="text-left">{{ getDate(pinnedDocument.creationDate) }}</div>
                  <div class="text-left">{{ pinnedDocument.filename }}</div>
                </div>
              </div>
            </div>
          }
        </div>
      }
        <div [ngClass]="{'mt-6':pinnedDocuments.length>0}" class="grid grid-cols-1 gap-2 items-center">
          @for (document of notPinnedDocuments; track document.id) {
            <div class="flex flex-col pt-1 w-full">
              <div class="flex">
                <div class="flex items-end pr-2">
                  @if (!pinLock){
                  <i class="material-symbols-outlined clickable" (click)="pinDocument(document)">keep</i>
                  }
                  <i class="material-symbols-outlined text-red-600 clickable"
                     (click)="openDeleteDocumentDialog(document)">delete</i>
                </div>
                <div class="clickable" (click)="openViewDocumentDialog(document.id)">
                  <div class="text-left">{{ getDate(document.creationDate) }}</div>
                  <div class="text-left">{{ document.filename }}</div>
                </div>
              </div>
            </div>
          }
        </div>
      </app-greedy-scroll-panel>
    }
  </div>
</div>
